module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus-pic.6b4e263e.png";